import React from "react";
import { Form, Input, Button, Card, message, InputNumber, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { useCreateStrategyMutation } from "../../../slices/strategyApiSlice"; // Import your mutation

const { TextArea } = Input;

const CreateStrategy = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // ✅ Hook for RTK Query mutation
  const [createStrategy, { isLoading }] = useCreateStrategyMutation();

  const onFinish = async (values) => {
    try {
      // Call mutation
      const response = await createStrategy(values).unwrap(); 
      message.success("Strategy Created Successfully");

      // Navigate to strategies page
      navigate("/all-Strategy");
    } catch (error) {
      message.error(error?.data?.message || "Error creating strategy");
    }
  };

  return (
    <Card title="Create Strategy" style={{ maxWidth: 600, margin: "auto" }}>
      <Form layout="vertical" form={form} onFinish={onFinish}>

        {/* Strategy Name */}
        <Form.Item
          label="Strategy Name"
          name="name"
          rules={[{ required: true, message: "Please enter strategy name" }]}
        >
          <Input placeholder="Example: BankNifty 9:20 Breakout" />
        </Form.Item>

        {/* Entry Rule */}
        <Form.Item
          label="Entry Rule"
          name="entryRule"
          rules={[{ required: true, message: "Please enter entry rule" }]}
        >
          <TextArea rows={3} placeholder="Describe entry condition..." />
        </Form.Item>

        {/* Exit Rule */}
        <Form.Item
          label="Exit Rule"
          name="exitRule"
          rules={[{ required: true, message: "Please enter exit rule" }]}
        >
          <TextArea rows={3} placeholder="Describe exit condition..." />
        </Form.Item>

        {/* Additional Notes */}
        <Form.Item label="Additional Notes" name="notes">
          <TextArea rows={3} placeholder="Optional notes..." />
        </Form.Item>

        {/* Optional Fields you commented */}
        {/*
        <Form.Item label="Risk % Per Trade" name="riskPercent">
          <InputNumber min={0} max={100} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item label="Risk Reward Ratio" name="riskReward">
          <Input placeholder="Example: 1:2" />
        </Form.Item>

        <Form.Item label="Timeframe" name="timeframe">
          <Select placeholder="Select timeframe">
            <Option value="1min">1 Min</Option>
            <Option value="5min">5 Min</Option>
            <Option value="15min">15 Min</Option>
            <Option value="1hr">1 Hour</Option>
            <Option value="1day">1 Day</Option>
          </Select>
        </Form.Item>
        */}

        <Button type="primary" htmlType="submit" block loading={isLoading}    className="gold-btn">
          Create Strategy
        </Button>
      </Form>
    </Card>
  );
};

export default CreateStrategy;